<template>
  <div>
    <v-form v-if="!formListLoader">
      <ValidationObserver ref="addressInfoValidationObserver">
        <v-row class="ma-4">
          <v-col cols="12" class="mb-8">
            <div class="body-1 primary--text font-weight-medium my-2">
              Permanent Address
              <span style="color: red">*</span>
            </div>
            <div class="d-flex py-3" style="width: 100%">
              <vue-google-autocomplete
                id="map"
                class="form-control pa-3"
                style="width: 100%; border: 1px solid #e0e0e0"
                placeholder="Please type your address"
                v-on:placechanged="setPermanentAddress"
                :fields="['address_components', 'geometry']"
                :enable-geolocation="true"
              ></vue-google-autocomplete>
            </div>
          </v-col>
          <!-- Apartment Name -->
          <v-col
            cols="12"
            xs="12"
            sm="6"
            lg="6"
            md="6"
            xl="6"
            v-if="
              formList[234] &&
              formList[234].Field_Visiblity.toLowerCase() === 'yes'
            "
          >
            <ValidationProvider
              ref="pApartmentNameProvider"
              v-slot="{ errors }"
              :name="formList[234].Field_Alias"
              vid="pApartmentName"
              :rules="
                formList[234].Mandatory_Field.toLowerCase() === 'yes'
                  ? 'required|multilingualNameNumericValidation'
                  : 'multilingualNameNumericValidation'
              "
            >
              <v-text-field
                :id="'pApartmentName'"
                v-model="pApartmentName"
                outlined
                :counter="255"
                :maxlength="255"
                :error-messages="errors"
                @input="onChangePermanentAddress()"
              >
                <template v-slot:label>
                  {{ formList[234].Field_Alias }}
                  <span
                    v-if="formList[234].Mandatory_Field.toLowerCase() === 'yes'"
                    style="color: red"
                    >*</span
                  >
                </template>
              </v-text-field>
            </ValidationProvider>
          </v-col>
          <!-- Street 2 -->
          <v-col
            cols="12"
            xs="12"
            sm="6"
            lg="6"
            md="6"
            xl="6"
            v-if="
              formList[240] &&
              formList[240].Field_Visiblity.toLowerCase() === 'yes'
            "
          >
            <ValidationProvider
              ref="pStreetProvider"
              v-slot="{ errors }"
              :name="formList[240].Field_Alias"
              :rules="
                formList[240].Mandatory_Field.toLowerCase() === 'yes'
                  ? 'required|multilingualNameNumericValidation'
                  : 'multilingualNameNumericValidation'
              "
            >
              <v-text-field
                :id="'pStreet'"
                v-model="pStreet"
                outlined
                :counter="255"
                :maxlength="255"
                :error-messages="errors"
                @input="onChangePermanentAddress()"
              >
                <template v-slot:label>
                  {{ formList[240].Field_Alias }}
                  <span
                    style="color: red"
                    v-if="formList[240].Mandatory_Field.toLowerCase() === 'yes'"
                    >*</span
                  >
                </template>
              </v-text-field>
            </ValidationProvider>
          </v-col>
          <!-- Barangay -->
          <v-col
            cols="12"
            xs="12"
            sm="6"
            lg="6"
            md="6"
            xl="6"
            v-if="
              formList[340] &&
              formList[340].Field_Visiblity.toLowerCase() === 'yes'
            "
          >
            <ValidationProvider
              ref="pBarangayProvider"
              v-slot="{ errors }"
              :name="formList[340].Field_Alias"
              vid="pBarangay"
              :rules="
                formList[340].Mandatory_Field.toLowerCase() === 'yes'
                  ? 'required|multilingualNameNumericValidation|max:100'
                  : 'multilingualNameNumericValidation|max:100'
              "
            >
              <v-autocomplete
                v-if="formList[340].Predefined.toLowerCase() === 'yes'"
                :id="'pBarangay'"
                v-model="pBarangayId"
                :items="pBarangayList"
                item-text="barangayDetails"
                item-value="Barangay_Id"
                outlined
                :error-messages="errors"
                placeholder="Type minimum 3 characters to list"
                :no-data-text="noDataTextForPBarangay"
                @change="handlePBarangayChange($event)"
                :loading="isPBarangayLoading"
                @update:search-input="callPBarangayList($event)"
              >
                <template v-slot:label>
                  {{ formList[340].Field_Alias }}
                  <span
                    style="color: red"
                    v-if="formList[340].Mandatory_Field.toLowerCase() === 'yes'"
                    >*</span
                  >
                </template>
              </v-autocomplete>
              <v-text-field
                v-else
                :id="'pBarangay'"
                v-model="pBarangay"
                counter="100"
                outlined
                :error-messages="errors"
                @input="onChangePermanentAddress()"
              >
                <template v-slot:label>
                  {{ formList[340].Field_Alias }}
                  <span
                    style="color: red"
                    v-if="formList[340].Mandatory_Field.toLowerCase() === 'yes'"
                    >*</span
                  >
                </template>
              </v-text-field>
            </ValidationProvider>
          </v-col>
          <!-- City -->
          <v-col
            cols="12"
            xs="12"
            sm="6"
            lg="6"
            md="6"
            xl="6"
            v-if="
              formList[699] &&
              formList[699].Field_Visiblity.toLowerCase() === 'yes'
            "
          >
            <ValidationProvider
              ref="pCityProvider"
              v-slot="{ errors }"
              name="City"
              :rules="
                formList[699].Mandatory_Field.toLowerCase() === 'yes'
                  ? 'required|multilingualNameNumericValidation'
                  : 'multilingualNameNumericValidation'
              "
            >
              <v-autocomplete
                v-if="formList[699].Predefined.toLowerCase() === 'yes'"
                :id="'pCity'"
                v-model="pCityId"
                :items="cityStateList"
                item-text="cityStateDetails"
                item-value="City_Id"
                outlined
                :error-messages="errors"
                @change="onChangePermanentAddress()"
              >
                <template v-slot:label>
                  {{ formList[699].Field_Alias }}
                  <span
                    v-if="formList[699].Mandatory_Field.toLowerCase() === 'yes'"
                    style="color: red"
                    >*</span
                  >
                </template>
              </v-autocomplete>
              <v-text-field
                v-else
                :id="'pCity'"
                v-model="pCity"
                outlined
                :error-messages="errors"
                @input="onChangePermanentAddress()"
              >
                <template v-slot:label>
                  {{ formList[699].Field_Alias }}
                  <span
                    v-if="formList[699].Mandatory_Field.toLowerCase() === 'yes'"
                    style="color: red"
                    >*</span
                  >
                </template>
              </v-text-field>
            </ValidationProvider>
          </v-col>
          <!-- State -->
          <v-col
            v-if="
              formList[402] &&
              formList[402].Field_Visiblity.toLowerCase() === 'yes'
            "
            cols="12"
            xs="12"
            sm="6"
            lg="6"
            md="6"
            xl="6"
          >
            <ValidationProvider
              ref="pStateProvider"
              v-slot="{ errors }"
              :name="stateLabel"
              :rules="
                formList[402].Mandatory_Field.toLowerCase() === 'yes'
                  ? 'required|multilingualNameNumericValidation'
                  : 'multilingualNameNumericValidation'
              "
            >
              <v-text-field
                :id="'pState'"
                v-model="pState"
                outlined
                :readonly="
                  pState && formList[402].Predefined.toLowerCase() === 'yes'
                    ? true
                    : false
                "
                :error-messages="errors"
                @input="onChangePermanentAddress()"
              >
                <template v-slot:label>
                  {{ stateLabel }}
                  <span
                    v-if="formList[402].Mandatory_Field.toLowerCase() === 'yes'"
                    style="color: red"
                    >*</span
                  >
                </template>
              </v-text-field>
            </ValidationProvider>
          </v-col>
          <!-- Region -->
          <v-col
            cols="12"
            xs="12"
            sm="6"
            lg="6"
            md="6"
            xl="6"
            v-if="
              formList[341] &&
              formList[341].Field_Visiblity.toLowerCase() === 'yes'
            "
          >
            <ValidationProvider
              ref="pRegionProvider"
              v-slot="{ errors }"
              :name="formList[341].Field_Alias"
              vid="pRegion"
              :rules="
                formList[341].Mandatory_Field.toLowerCase() === 'yes'
                  ? 'required|multilingualNameNumericValidation|max:100'
                  : 'multilingualNameNumericValidation|max:100'
              "
            >
              <v-autocomplete
                v-if="formList[341].Predefined.toLowerCase() === 'yes'"
                :id="'pRegion'"
                v-model="pRegion"
                :items="cityStateList"
                item-text="cityStateDetails"
                item-value="cityStateDetails"
                outlined
                :error-messages="errors"
                @change="onChangePermanentAddress()"
              >
                <template v-slot:label>
                  {{ formList[341].Field_Alias }}
                  <span
                    style="color: red"
                    v-if="formList[341].Mandatory_Field.toLowerCase() === 'yes'"
                    >*</span
                  >
                </template>
              </v-autocomplete>
              <v-text-field
                v-else
                :id="'pRegion'"
                v-model="pRegion"
                counter="100"
                outlined
                :error-messages="errors"
                @input="onChangePermanentAddress()"
              >
                <template v-slot:label>
                  {{ formList[341].Field_Alias }}
                  <span
                    style="color: red"
                    v-if="formList[341].Mandatory_Field.toLowerCase() === 'yes'"
                    >*</span
                  >
                </template>
              </v-text-field>
            </ValidationProvider>
          </v-col>
          <!-- Country -->
          <v-col
            v-if="
              formList[700] &&
              formList[700].Field_Visiblity.toLowerCase() === 'yes'
            "
            cols="12"
            xs="12"
            sm="6"
            lg="6"
            md="6"
            xl="6"
          >
            <ValidationProvider
              ref="pCountryProvider"
              v-slot="{ errors }"
              :name="formList[700].Field_Alias"
              :rules="
                formList[700].Mandatory_Field.toLowerCase() === 'yes'
                  ? 'required|multilingualNameNumericValidation'
                  : 'multilingualNameNumericValidation'
              "
            >
              <v-autocomplete
                :id="'pCountry'"
                v-model="pCountry"
                :items="countryList"
                item-text="Country_Name"
                item-value="Country_Code"
                outlined
                label="Country*"
                :error-messages="errors"
                @change="onChangePermanentAddress()"
              >
                <template v-slot:label>
                  {{ formList[700].Field_Alias }}
                  <span
                    v-if="formList[700].Mandatory_Field.toLowerCase() === 'yes'"
                    style="color: red"
                    >*</span
                  >
                </template>
              </v-autocomplete>
            </ValidationProvider>
          </v-col>
          <!-- Pincode -->
          <v-col
            cols="12"
            xs="12"
            sm="6"
            lg="6"
            md="6"
            xl="6"
            v-if="
              formList[144] &&
              formList[144].Field_Visiblity.toLowerCase() === 'yes'
            "
          >
            <ValidationProvider
              ref="pPincodeProvider"
              v-slot="{ errors }"
              :name="formList[144].Field_Alias"
              :rules="
                formList[144].Mandatory_Field.toLowerCase() === 'yes'
                  ? `required|min:${formList[144].Min_Validation || 1}|max:${
                      formList[144].Max_Validation || 30
                    }|regex:${formList[144].Validation_Id || 4}`
                  : `min:${formList[144].Min_Validation || 1}|max:${
                      formList[144].Max_Validation || 30
                    }|regex:${formList[144].Validation_Id || 4}`
              "
            >
              <v-text-field
                :id="'pPincode'"
                v-model="pPincode"
                outlined
                :counter="formList[144].Max_Validation || 30"
                :maxlength="formList[144].Max_Validation || 30"
                label="Postal Code*"
                :error-messages="errors"
                @input="onChangePermanentAddress()"
              >
                <template v-slot:label>
                  {{ formList[144].Field_Alias }}
                  <span
                    v-if="formList[144].Mandatory_Field.toLowerCase() === 'yes'"
                    style="color: red"
                    >*</span
                  >
                </template>
              </v-text-field>
            </ValidationProvider>
          </v-col>
          <v-col cols="12">
            <div class="body-1 primary--text font-weight-medium my-2">
              Current Address*
            </div>
            <div style="max-width: 260px">
              <v-switch
                v-model="sameAsPermanent"
                inset
                :true-value="1"
                :false-value="0"
                color="primary"
                label="Same as permanent address"
                @change="onChangeAddressFlag()"
              ></v-switch>
            </div>
            <div
              v-if="!sameAsPermanent"
              class="d-flex pb-3 mb-8"
              style="width: 100%"
            >
              <vue-google-autocomplete
                id="map1"
                class="form-control pa-3"
                style="width: 100%; border: 1px solid #e0e0e0"
                placeholder="Please type your address"
                v-on:placechanged="setCurrentAddress"
                :enable-geolocation="true"
                :fields="['address_components', 'geometry']"
              ></vue-google-autocomplete>
            </div>
          </v-col>
          <!-- Apartment Name -->
          <v-col
            cols="12"
            xs="12"
            sm="6"
            lg="6"
            md="6"
            xl="6"
            v-if="
              formList[235] &&
              formList[235].Field_Visiblity.toLowerCase() === 'yes'
            "
          >
            <ValidationProvider
              ref="cApartmentNameProvider"
              v-slot="{ errors }"
              :name="formList[235].Field_Alias"
              vid="cApartmentName"
              :rules="
                formList[235].Mandatory_Field.toLowerCase() === 'yes'
                  ? 'required|multilingualNameNumericValidation'
                  : 'multilingualNameNumericValidation'
              "
            >
              <v-text-field
                :id="'cApartmentName'"
                v-model="cApartmentName"
                label="Street 1*"
                outlined
                :counter="255"
                :maxlength="255"
                :error-messages="errors"
                :disabled="sameAsPermanent ? true : false"
              >
                <template v-slot:label>
                  {{ formList[235].Field_Alias }}
                  <span
                    v-if="formList[235].Mandatory_Field.toLowerCase() === 'yes'"
                    style="color: red"
                    >*</span
                  >
                </template></v-text-field
              >
            </ValidationProvider>
          </v-col>
          <!-- Street 2 -->
          <v-col
            cols="12"
            xs="12"
            sm="6"
            lg="6"
            md="6"
            xl="6"
            v-if="
              formList[701] &&
              formList[701].Field_Visiblity.toLowerCase() === 'yes'
            "
          >
            <ValidationProvider
              ref="cStreetProvider"
              v-slot="{ errors }"
              :name="formList[701].Field_Alias"
              :rules="
                formList[701].Mandatory_Field.toLowerCase() === 'yes'
                  ? 'required|multilingualNameNumericValidation'
                  : 'multilingualNameNumericValidation'
              "
            >
              <v-text-field
                :id="'cStreet'"
                v-model="cStreet"
                outlined
                :label="formList[701].Field_Alias"
                :counter="255"
                :maxlength="255"
                :error-messages="errors"
                :disabled="sameAsPermanent ? true : false"
              >
                <template v-slot:label>
                  {{ formList[701].Field_Alias }}
                  <span
                    v-if="formList[701].Mandatory_Field.toLowerCase() === 'yes'"
                    style="color: red"
                    >*</span
                  >
                </template>
              </v-text-field>
            </ValidationProvider>
          </v-col>
          <!-- Barangay -->
          <v-col
            cols="12"
            xs="12"
            sm="6"
            lg="6"
            md="6"
            xl="6"
            v-if="
              formList[342] &&
              formList[342].Field_Visiblity.toLowerCase() === 'yes'
            "
          >
            <ValidationProvider
              ref="cBarangayProvider"
              v-slot="{ errors }"
              :name="formList[342].Field_Alias"
              vid="cBarangay"
              :rules="
                formList[342].Mandatory_Field.toLowerCase() === 'yes'
                  ? 'required|multilingualNameNumericValidation|max:100'
                  : 'multilingualNameNumericValidation|max:100'
              "
            >
              <v-autocomplete
                v-if="formList[342].Predefined.toLowerCase() === 'yes'"
                :id="'cBarangay'"
                v-model="cBarangayId"
                :items="cBarangayList"
                item-text="barangayDetails"
                item-value="Barangay_Id"
                :no-data-text="noDataTextForCBarangay"
                :disabled="sameAsPermanent ? true : false"
                outlined
                :loading="isCBarangayLoading"
                :error-messages="errors"
                placeholder="Type minimum 3 characters to list"
                @change="handleCBarangayChange($event)"
                @update:search-input="callCBarangayList($event)"
              >
                <template v-slot:label>
                  {{ formList[342].Field_Alias }}
                  <span
                    style="color: red"
                    v-if="formList[342].Mandatory_Field.toLowerCase() === 'yes'"
                    >*</span
                  >
                </template>
              </v-autocomplete>
              <v-text-field
                v-else
                :id="'cBarangay'"
                v-model="cBarangay"
                :disabled="sameAsPermanent ? true : false"
                outlined
                counter="100"
                :error-messages="errors"
                @input="onChangePermanentAddress()"
              >
                <template v-slot:label>
                  {{ formList[342].Field_Alias }}
                  <span
                    style="color: red"
                    v-if="formList[342].Mandatory_Field.toLowerCase() === 'yes'"
                    >*</span
                  >
                </template>
              </v-text-field>
            </ValidationProvider>
          </v-col>
          <!-- City -->
          <v-col
            cols="12"
            xs="12"
            sm="6"
            lg="6"
            md="6"
            xl="6"
            v-if="
              formList[137] &&
              formList[137].Field_Visiblity.toLowerCase() === 'yes'
            "
          >
            <ValidationProvider
              ref="cCityProvider"
              v-slot="{ errors }"
              :name="formList[137].Field_Alias"
              :rules="
                formList[137].Mandatory_Field.toLowerCase() === 'yes'
                  ? 'required|multilingualNameNumericValidation'
                  : 'multilingualNameNumericValidation'
              "
            >
              <v-autocomplete
                v-if="formList[137].Predefined.toLowerCase() === 'yes'"
                :id="'cCity'"
                v-model="cCityId"
                :items="cityStateList"
                item-text="cityStateDetails"
                item-value="City_Id"
                outlined
                :counter="50"
                :maxlength="50"
                :error-messages="errors"
                :disabled="sameAsPermanent ? true : false"
              >
                <template v-slot:label>
                  {{ formList[137].Field_Alias }}
                  <span
                    v-if="formList[137].Mandatory_Field.toLowerCase() === 'yes'"
                    style="color: red"
                    >*</span
                  >
                </template></v-autocomplete
              >
              <v-text-field
                v-else
                :id="'cCity'"
                v-model="cCity"
                outlined
                :error-messages="errors"
                @input="onChangePermanentAddress()"
                :disabled="sameAsPermanent ? true : false"
              >
                <template v-slot:label>
                  {{ formList[137].Field_Alias }}
                  <span
                    v-if="formList[137].Mandatory_Field.toLowerCase() === 'yes'"
                    style="color: red"
                    >*</span
                  >
                </template>
              </v-text-field>
            </ValidationProvider>
          </v-col>
          <!-- State -->
          <v-col
            v-if="
              formList[702] &&
              formList[702].Field_Visiblity.toLowerCase() === 'yes'
            "
            cols="12"
            xs="12"
            sm="6"
            lg="6"
            md="6"
            xl="6"
          >
            <ValidationProvider
              ref="cStateProvider"
              v-slot="{ errors }"
              :name="formList[702].Field_Alias"
              :rules="
                formList[702].Mandatory_Field.toLowerCase() === 'yes'
                  ? 'required|multilingualNameNumericValidation'
                  : 'multilingualNameNumericValidation'
              "
            >
              <v-text-field
                :id="'cState'"
                v-model="cState"
                outlined
                :readonly="
                  cState && formList[402].Predefined.toLowerCase() === 'yes'
                    ? true
                    : false
                "
                :error-messages="errors"
                :disabled="sameAsPermanent ? true : false"
              >
                <template v-slot:label>
                  {{ formList[702].Field_Alias }}
                  <span
                    v-if="formList[702].Mandatory_Field.toLowerCase() === 'yes'"
                    style="color: red"
                    >*</span
                  >
                </template>
              </v-text-field>
            </ValidationProvider>
          </v-col>
          <!-- Region -->
          <v-col
            cols="12"
            xs="12"
            sm="6"
            lg="6"
            md="6"
            xl="6"
            v-if="
              formList[343] &&
              formList[343].Field_Visiblity.toLowerCase() === 'yes'
            "
          >
            <ValidationProvider
              ref="cRegionProvider"
              v-slot="{ errors }"
              :name="formList[343].Field_Alias"
              vid="cRegion"
              :rules="
                formList[343].Mandatory_Field.toLowerCase() === 'yes'
                  ? 'required|multilingualNameNumericValidation|max:100'
                  : 'multilingualNameNumericValidation|max:100'
              "
            >
              <v-autocomplete
                v-if="formList[343].Predefined.toLowerCase() === 'yes'"
                :id="'cRegion'"
                v-model="cRegion"
                :items="cityStateList"
                item-text="cityStateDetails"
                item-value="cityStateDetails"
                :disabled="sameAsPermanent ? true : false"
                outlined
                :error-messages="errors"
                @change="onChangePermanentAddress()"
              >
                <template v-slot:label>
                  {{ formList[343].Field_Alias }}
                  <span
                    style="color: red"
                    v-if="formList[343].Mandatory_Field.toLowerCase() === 'yes'"
                    >*</span
                  >
                </template>
              </v-autocomplete>
              <v-text-field
                v-else
                :id="'cRegion'"
                v-model="cRegion"
                outlined
                counter="100"
                :disabled="sameAsPermanent ? true : false"
                :error-messages="errors"
                @input="onChangePermanentAddress()"
              >
                <template v-slot:label>
                  {{ formList[343].Field_Alias }}
                  <span
                    style="color: red"
                    v-if="formList[343].Mandatory_Field.toLowerCase() === 'yes'"
                    >*</span
                  >
                </template>
              </v-text-field>
            </ValidationProvider>
          </v-col>
          <!-- Country -->
          <v-col
            v-if="
              formList[703] &&
              formList[703].Field_Visiblity.toLowerCase() === 'yes'
            "
            cols="12"
            xs="12"
            sm="6"
            lg="6"
            md="6"
            xl="6"
          >
            <ValidationProvider
              ref="cCountryProvider"
              v-slot="{ errors }"
              :name="formList[703].Field_Alias"
              :rules="
                formList[703].Mandatory_Field.toLowerCase() === 'yes'
                  ? 'required'
                  : ''
              "
            >
              <v-autocomplete
                :id="'cCountry'"
                v-model="cCountry"
                :items="countryList"
                item-text="Country_Name"
                item-value="Country_Code"
                outlined
                :readonly="cCountry ? true : false"
                :error-messages="errors"
                @change="onChangePermanentAddress()"
                :disabled="sameAsPermanent ? true : false"
              >
                <template v-slot:label>
                  {{ formList[703].Field_Alias }}
                  <span
                    v-if="formList[703].Mandatory_Field.toLowerCase() === 'yes'"
                    style="color: red"
                    >*</span
                  >
                </template>
              </v-autocomplete>
            </ValidationProvider>
          </v-col>
          <!-- Pincode -->
          <v-col
            cols="12"
            xs="12"
            sm="6"
            lg="6"
            md="6"
            xl="6"
            v-if="
              formList[704] &&
              formList[704].Field_Visiblity.toLowerCase() === 'yes'
            "
          >
            <ValidationProvider
              ref="cPincodeProvider"
              v-slot="{ errors }"
              :name="formList[704].Field_Alias"
              :rules="
                formList[704].Mandatory_Field.toLowerCase() === 'yes'
                  ? `required|min:${formList[704].Min_Validation || 1}|max:${
                      formList[704].Max_Validation || 30
                    }|regex:${formList[704].Validation_Id || 4}`
                  : `min:${formList[704].Min_Validation || 1}|max:${
                      formList[704].Max_Validation || 30
                    }|regex:${formList[704].Validation_Id || 4}`
              "
            >
              <v-text-field
                :id="'cPincode'"
                v-model="cPincode"
                outlined
                :counter="formList[704].Max_Validation || 30"
                :maxlength="formList[704].Max_Validation || 30"
                :error-messages="errors"
                :disabled="sameAsPermanent ? true : false"
              >
                <template v-slot:label>
                  {{ formList[704].Field_Alias }}
                  <span
                    v-if="formList[704].Mandatory_Field.toLowerCase() === 'yes'"
                    style="color: red"
                    >*</span
                  >
                </template>
              </v-text-field>
            </ValidationProvider>
          </v-col>
          <v-col cols="12">
            <div class="body-1 primary--text font-weight-medium my-2">
              Contact Details
            </div>
          </v-col>
          <v-col cols="12" xs="12" sm="6" lg="6" md="6" xl="6">
            <VueTelInput
              class="pa-2 pb-3"
              v-model="mobileNo"
              :preferred-countries="['IN', 'US', 'AU']"
              :error="!!mobileNumberValidation"
              error-color="#E53935"
              valid-color="#9E9E9E"
              :inputOptions="mobileNumberTranslation"
              :default-country="getCountryCode(mobileNoCountryCode)"
              :valid-characters-only="true"
              @input="updateMobileNumber"
            ></VueTelInput>
            <span
              :class="
                mobileNumberValidation
                  ? 'red--text caption mt-1'
                  : 'green--text caption mt-1'
              "
              >{{ mobileNumberValidation }}</span
            >
          </v-col>
          <!-- Telephone Number -->
          <v-col
            v-if="
              formList[604] &&
              formList[604].Field_Visiblity.toLowerCase() === 'yes'
            "
            cols="12"
            xs="12"
            sm="6"
            lg="6"
            md="6"
            xl="6"
          >
            <ValidationProvider
              ref="landlineNoProvider"
              v-slot="{ errors }"
              :name="formList[604].Field_Alias"
              :rules="{
                required: formList[604].Mandatory_Field === 'Yes',
                min: 6,
                max: 15,
              }"
            >
              <v-text-field
                :id="'landlineNo'"
                v-model="landlineNo"
                outlined
                :counter="15"
                :maxlength="15"
                :error-messages="errors"
              >
                <template v-slot:label>
                  {{ formList[604].Field_Alias }}
                  <span
                    v-if="formList[604].Mandatory_Field.toLowerCase() === 'yes'"
                    style="color: red"
                    >*</span
                  >
                </template>
              </v-text-field>
            </ValidationProvider>
          </v-col>
          <!-- Emergency Contact Name -->
          <v-col
            v-if="
              formList[435] &&
              formList[435].Field_Visiblity.toLowerCase() === 'yes'
            "
            cols="12"
            xs="12"
            sm="6"
            lg="6"
            md="6"
            xl="6"
          >
            <ValidationProvider
              ref="emergencyContactNameProvider"
              v-slot="{ errors }"
              :name="formList[435].Field_Alias"
              :rules="
                formList[435].Mandatory_Field.toLowerCase() === 'yes'
                  ? 'required|multilingualNameValidation|min:1|max:100'
                  : 'multilingualNameValidation|min:1|max:100'
              "
            >
              <v-text-field
                :id="'emergencyContactName'"
                v-model="emergencyContactName"
                :counter="100"
                :max-length="100"
                outlined
                :error-messages="errors"
                ><template v-slot:label>
                  {{ formList[435].Field_Alias }}
                  <span
                    v-if="formList[435].Mandatory_Field.toLowerCase() === 'yes'"
                    style="color: red"
                    >*</span
                  >
                </template></v-text-field
              >
            </ValidationProvider>
          </v-col>
          <!-- Emergency Contact Number -->
          <v-col
            v-if="
              formList[436] &&
              formList[436].Field_Visiblity.toLowerCase() === 'yes'
            "
            cols="12"
            xs="12"
            sm="6"
            lg="6"
            md="6"
            xl="6"
          >
            <ValidationProvider
              ref="emergencyContactProvider"
              v-slot="{ errors }"
              :name="formList[436].Field_Alias"
              :rules="{
                required: formList[436].Mandatory_Field === 'Yes',
                min: 6,
                max: 15,
              }"
            >
              <v-text-field
                :id="'emergencyContactNo'"
                v-model="emergencyContactNo"
                outlined
                :counter="15"
                :maxlength="15"
                :error-messages="errors"
              >
                <template v-slot:label>
                  {{ formList[436].Field_Alias }}
                  <span
                    v-if="formList[436].Mandatory_Field.toLowerCase() === 'yes'"
                    style="color: red"
                    >*</span
                  >
                </template></v-text-field
              >
            </ValidationProvider>
          </v-col>
          <!-- Emergency Contact Relation -->
          <v-col
            v-if="
              formList[437] &&
              formList[437].Field_Visiblity.toLowerCase() === 'yes'
            "
            cols="12"
            xs="12"
            sm="6"
            lg="6"
            md="6"
            xl="6"
          >
            <ValidationProvider
              ref="emergencyContactRelationProvider"
              v-slot="{ errors }"
              :name="formList[437].Field_Alias"
              :rules="
                formList[437].Mandatory_Field.toLowerCase() === 'yes'
                  ? 'required|alphaSpaceDot|min:3|max:30'
                  : 'alphaSpaceDot|min:3|max:30'
              "
            >
              <v-text-field
                :id="'emergencyContactRelation'"
                v-model="emergencyContactRelation"
                outlined
                :counter="30"
                :maxlength="30"
                :error-messages="errors"
              >
                <template v-slot:label>
                  {{ formList[437].Field_Alias }}
                  <span
                    v-if="formList[437].Mandatory_Field.toLowerCase() === 'yes'"
                    style="color: red"
                    >*</span
                  >
                </template></v-text-field
              >
            </ValidationProvider>
          </v-col>
          <!-- Emergency Contact Address -->
          <v-col
            v-if="
              formList[769] &&
              formList[769].Field_Visiblity.toLowerCase() === 'yes'
            "
            cols="12"
            xs="12"
            sm="6"
            lg="6"
            md="6"
            xl="6"
          >
            <ValidationProvider
              ref="emergencyContactAddressProvider"
              v-slot="{ errors }"
              :name="formList[769].Field_Alias"
              :rules="
                formList[769].Mandatory_Field.toLowerCase() === 'yes'
                  ? 'required'
                  : ''
              "
            >
              <v-text-field
                :id="'Emergency_Contact_Address'"
                v-model="emergencyContactAddress"
                outlined
                :counter="250"
                :maxlength="250"
                :error-messages="errors"
              >
                <template v-slot:label>
                  {{ formList[769].Field_Alias }}
                  <span
                    v-if="formList[769].Mandatory_Field.toLowerCase() === 'yes'"
                    style="color: red"
                    >*</span
                  >
                </template></v-text-field
              >
            </ValidationProvider>
          </v-col>
          <!-- Emergency Contact City -->
          <v-col
            v-if="
              formList[770] &&
              formList[770].Field_Visiblity.toLowerCase() === 'yes'
            "
            cols="12"
            xs="12"
            sm="6"
            lg="6"
            md="6"
            xl="6"
          >
            <ValidationProvider
              ref="emergencyContactCityProvider"
              v-slot="{ errors }"
              :name="formList[770].Field_Alias"
              :rules="
                formList[770].Mandatory_Field.toLowerCase() === 'yes'
                  ? 'required'
                  : ''
              "
            >
              <v-text-field
                :id="'Emergency_Contact_City'"
                v-model="emergencyContactCity"
                outlined
                :counter="50"
                :maxlength="50"
                :error-messages="errors"
              >
                <template v-slot:label>
                  {{ formList[770].Field_Alias }}
                  <span
                    v-if="formList[770].Mandatory_Field.toLowerCase() === 'yes'"
                    style="color: red"
                    >*</span
                  >
                </template></v-text-field
              >
            </ValidationProvider>
          </v-col>
          <!-- Emergency Contact Country -->
          <v-col
            v-if="
              formList[771] &&
              formList[771].Field_Visiblity.toLowerCase() === 'yes'
            "
            cols="12"
            xs="12"
            sm="6"
            lg="6"
            md="6"
            xl="6"
          >
            <ValidationProvider
              ref="emergencyContactCountryProvider"
              v-slot="{ errors }"
              :name="formList[771].Field_Alias"
              :rules="
                formList[771].Mandatory_Field.toLowerCase() === 'yes'
                  ? 'required'
                  : ''
              "
            >
              <v-text-field
                :id="'Emergency_Contact_Country'"
                v-model="emergencyContactCountry"
                outlined
                :counter="50"
                :maxlength="50"
                :error-messages="errors"
              >
                <template v-slot:label>
                  {{ formList[771].Field_Alias }}
                  <span
                    v-if="formList[771].Mandatory_Field.toLowerCase() === 'yes'"
                    style="color: red"
                    >*</span
                  >
                </template></v-text-field
              >
            </ValidationProvider>
          </v-col>
        </v-row>
      </ValidationObserver>
    </v-form>
    <v-overlay absolute :value="formListLoader" color="#fff" z-index="1">
      <v-progress-circular
        color="primary"
        indeterminate
        size="50"
      ></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import {
  LIST_COUNTRY,
  GET_CITY_LIST_WITH_STATE,
  GET_FORM_FIELDS_AND_TYPE,
  LIST_BARANGAY,
} from "@/graphql/OnboardingQueries";
import VueGoogleAutocomplete from "vue-google-autocomplete";
import { VueTelInput } from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";
import { scrollScreenToTop } from "../../../helper";

export default {
  name: "AddressInfo",

  components: {
    VueGoogleAutocomplete,
    VueTelInput,
  },

  props: {
    personalInfo: {
      type: Object,
      required: true,
    },
  },

  computed: {
    noDataTextForPBarangay() {
      if (this.isPBarangayLoading) {
        return "Loading...";
      } else if (
        !this.isPBarangayLoading &&
        this.pBarangayList &&
        this.pBarangayList.length == 0 &&
        this.pSearchString &&
        this.pSearchString.length >= 3
      ) {
        return "no data found";
      } else {
        return "Type minimum 3 characters to list";
      }
    },
    noDataTextForCBarangay() {
      if (this.isCBarangayLoading) {
        return "Loading...";
      } else if (
        !this.isCBarangayLoading &&
        this.cBarangayList &&
        this.cBarangayList.length == 0 &&
        this.cSearchString &&
        this.cSearchString.length >= 3
      ) {
        return "no data found";
      } else {
        return "Type minimum 3 characters to list";
      }
    },
    stateLabel() {
      return this.formList[402] && this.formList[402].Field_Alias
        ? this.formList[402].Field_Alias
        : "State";
    },
    mobileNumberValidation() {
      if (!this.mobileNo || !this.mobileNoCountryCode) {
        return "Mobile number is required / Provide a valid mobile number";
      } else if (this.mobileNo) {
        return this.mobileNumberProps.valid
          ? ""
          : "Please provide a valid mobile number";
      }
      return "";
    },
  },

  data: () => ({
    //   fields
    permanentAddress: "",
    currentAddress: "",
    pApartmentName: "",
    pStreet: "",
    pCityId: null,
    pCity: "",
    pBarangay: "",
    pBarangayId: null,
    pRegion: "",
    pState: "",
    pCountry: "",
    pPincode: "",
    cApartmentName: "",
    cStreet: "",
    cCityId: null,
    cCity: "",
    cBarangay: "",
    cBarangayId: null,
    cRegion: "",
    cState: "",
    cCountry: "",
    cPincode: "",
    emergencyContactNo: "",
    emergencyContactName: null,
    emergencyContactRelation: null,
    emergencyContactAddress: null,
    emergencyContactCity: null,
    emergencyContactCountry: null,
    landlineNo: "",
    mobileNo: "",
    mobileNoCountryCode: "",
    cityStateList: [],

    //   others
    countryList: [],
    sameAsPermanent: 0,
    mobileNumberTranslation: {
      placeholder: "Mobile Number *",
    },
    mobileNumberProps: {},
    cityLoading: false,
    formList: [],
    formListLoader: false,
    pBarangayList: [],
    cBarangayList: [],
    isPBarangayLoading: false,
    isCBarangayLoading: false,
    pSearchString: "",
    cSearchString: "",
  }),

  watch: {
    pCityId(val) {
      if (val != null) {
        for (let item of this.cityStateList) {
          if (item.City_Id == val) {
            this.pCity = item.City_Name;
            let details = item.cityStateDetails.split(", ");
            this.pCity = item.City_Name;
            this.pState = details[1];
            this.pCountry = item.Country_Code;
          }
        }
      }
    },
    cCityId(val) {
      if (val != null) {
        for (let item of this.cityStateList) {
          if (item.City_Id == val) {
            this.cCity = item.City_Name;
            let details = item.cityStateDetails.split(", ");
            this.cCity = item.City_Name;
            this.cState = details[1];
            this.cCountry = item.Country_Code;
          }
        }
      }
    },
    sameAsPermanent(val) {
      if (val == false) {
        this.cApartmentName = "";
        this.cStreet = "";
        this.cCityId = null;
        this.cCity = "";
        this.cBarangay = "";
        this.cBarangayId = null;
        this.cRegion = "";
        this.cState = "";
        this.cCountry = "";
        this.cPincode = "";
      }
    },
    personalInfo(val) {
      for (let item of this.cityStateList) {
        if (item.City_Name == val.pCity) {
          this.pCityId = item.City_Id;
          this.pCity = item.City_Name;
        }
        if (item.City_Name == val.cCity) {
          this.cCityId = item.City_Id;
          this.cCity = item.City_Name;
        }
      }
    },
  },

  apollo: {
    getCityListWithState: {
      query: GET_CITY_LIST_WITH_STATE,
      client: "apolloClientB",
      result({ data }) {
        this.cityStateList = data.getCityListWithState.cityDetails;
      },
    },
    listCountry: {
      query: LIST_COUNTRY,
      client: "apolloClientA",
      variables() {
        return {
          Org_Code: localStorage.getItem("orgCode"),
          Url_Hash: localStorage.getItem("urlHash"),
        };
      },
      result({ data }) {
        if (data && data.listCountry) {
          this.countryList = data.listCountry.country;
        }
      },
    },
  },

  mounted() {
    scrollScreenToTop();
    this.getFieldProps();
    if (this.personalInfo && Object.keys(this.personalInfo).length > 0) {
      this.pApartmentName = this.personalInfo.pApartment_Name;
      this.pStreet = this.personalInfo.pStreet_Name;
      this.pState = this.personalInfo.pState;
      this.pCityId = this.personalInfo.pCity_Id;
      this.pCity = this.personalInfo.pCity;
      this.pRegion = this.personalInfo?.pRegion;
      this.pBarangayId = this.personalInfo?.pBarangay_Id;
      this.pBarangay = this.personalInfo?.pBarangay; // this will give us pBarangay name
      if (this.pBarangay) this.callPBarangayList(this.pBarangay);
      this.pCountry = this.personalInfo.pCountry;
      this.pPincode = this.personalInfo.pPincode;
      this.cApartmentName = this.personalInfo.cApartment_Name;
      this.cStreet = this.personalInfo.cStreet_Name;
      this.cCityId = this.personalInfo.cCity_Id;
      this.cCity = this.personalInfo.cCity;
      this.cRegion = this.personalInfo?.cRegion;
      this.cBarangayId = this.personalInfo?.cBarangay_Id;
      this.cBarangay = this.personalInfo?.cBarangay;
      if (this.cBarangay) this.callCBarangayList(this.cBarangay);
      this.cState = this.personalInfo.cState;
      this.cCountry = this.personalInfo.cCountry;
      this.cPincode = this.personalInfo.cPincode;
      this.emergencyContactNo = this.personalInfo.Fax_No;
      this.mobileNo = this.personalInfo.Mobile_No
        ? this.personalInfo.Mobile_No
        : "";
      this.mobileNoCountryCode = this.personalInfo.Mobile_No_Country_Code
        ? this.personalInfo.Mobile_No_Country_Code
        : "";
      this.mobileNo = this.mobileNoCountryCode
        ? this.mobileNoCountryCode + this.mobileNo
        : this.mobileNo;
      this.landlineNo = this.personalInfo.Land_Line_No;
      this.sameAsPermanent = this.personalInfo.Use_Location_Address;
      this.emergencyContactName = this.personalInfo.Emergency_Contact_Name;
      this.emergencyContactRelation =
        this.personalInfo.Emergency_Contact_Relation;
      this.emergencyContactAddress =
        this.personalInfo.Emergency_Contact_Address;
      this.emergencyContactCity = this.personalInfo.Emergency_Contact_City;
      this.emergencyContactCountry =
        this.personalInfo.Emergency_Contact_Country;
    }
  },

  methods: {
    callPBarangayList(searchString) {
      this.pSearchString = searchString;
      if (searchString && searchString.length >= 3) {
        this.retrieveBarangay(searchString, "pBarangay");
      }
    },
    callCBarangayList(searchString) {
      this.cSearchString = searchString;
      if (searchString && searchString.length >= 3) {
        this.retrieveBarangay(searchString, "cBarangay");
      }
    },
    retrieveBarangay(searchString, type) {
      const vm = this;
      const typeMap = {
        pBarangay: {
          loadingKey: "isPBarangayLoading",
          listKey: "pBarangayList",
        },
        cBarangay: {
          loadingKey: "isCBarangayLoading",
          listKey: "cBarangayList",
        },
      };

      const config = typeMap[type];
      if (!config) return;

      vm[config.loadingKey] = true;

      vm.$apollo
        .query({
          query: LIST_BARANGAY,
          client: "apolloClientB",
          fetchPolicy: "no-cache",
          variables: { searchString },
        })
        .then((response) => {
          const data = response?.data?.getBarangayListWithCity;
          if (data && !data.errorCode && data.barangayDetails?.length) {
            vm[config.listKey] = data.barangayDetails;
          }
        })
        .catch(() => {
          vm[config.listKey] = [];
        })
        .finally(() => {
          vm[config.loadingKey] = false;
        });
    },
    getFieldProps() {
      let vm = this;
      vm.formListLoader = true;
      this.$apollo
        .query({
          query: GET_FORM_FIELDS_AND_TYPE,
          variables: {
            form_Id: 178,
          },
          client: "apolloClientB",
        })
        .then((res) => {
          if (res.data.getFormFeildsByFormIdAndTab) {
            res.data.getFormFeildsByFormIdAndTab.formFields.forEach((list) => {
              this.formList[list.Field_Id] = list;
              if (
                this.formList[699] &&
                this.formList[699].Predefined == "Yes"
              ) {
                for (let item of this.cityStateList) {
                  if (this.pCity) {
                    if (
                      item.City_Name.toLowerCase() === this.pCity.toLowerCase()
                    ) {
                      this.pCityId = item.City_Id;
                      this.pCity = item.City_Name;
                    }
                  }
                  if (this.cCity) {
                    if (
                      item.City_Name.toLowerCase() === this.cCity.toLowerCase()
                    ) {
                      this.cCityId = item.City_Id;
                      this.cCity = item.City_Name;
                    }
                  }
                }
              }
            });
          }
          vm.formListLoader = false;
        })
        .catch(() => {
          vm.formListLoader = false;
        });
    },
    // show error or success message
    showAlert(snackbarData) {
      this.$store.commit("OPEN_SNACKBAR", snackbarData);
    },

    getCountryCode(mobileNoCountryCode) {
      if (mobileNoCountryCode) {
        let countryCode = parseInt(mobileNoCountryCode);
        return countryCode;
      } else {
        return "";
      }
    },
    onChangePBarangay(val) {
      if (this.formList[340] && this.formList[340].Predefined === "Yes") {
        let filterCity = this.pBarangayList.filter(
          (el) => el.Barangay_Id == val
        );
        if (filterCity && filterCity[0]) {
          this.pBarangay = filterCity[0].Barangay_Name;
          this.pRegion = filterCity[0].Region_Name;
          this.pCityId = filterCity[0].City_Id;
          this.pCity = filterCity[0].City_Name;
          this.pState = filterCity[0].State_Name;
          this.pCountry = filterCity[0].Country_Code;
        }
      }
    },
    onChangeCBarangay(val) {
      if (this.formList[342] && this.formList[342].Predefined === "Yes") {
        let filterCity = this.cBarangayList.filter(
          (el) => el.Barangay_Id == val
        );
        if (filterCity && filterCity[0]) {
          this.cBarangay = filterCity[0].Barangay_Name;
          this.cRegion = filterCity[0].Region_Name;
          this.cCityId = filterCity[0]?.City_Id;
          this.cCity = filterCity[0]?.City_Name;
          this.cState = filterCity[0].State_Name;
          this.cCountry = filterCity[0].Country_Code;
        }
      }
    },
    handlePBarangayChange(value) {
      this.onChangePermanentAddress();
      this.onChangePBarangay(value);
    },
    handleCBarangayChange(value) {
      this.onChangePermanentAddress();
      this.onChangeCBarangay(value);
    },
    updateMobileNumber(payload, payload2) {
      this.mobileNumberProps = payload2;
      if (payload2 && Object.keys(payload2).length > 0) {
        this.mobileNo = payload2.nationalNumber;
        this.mobileNoCountryCode = "+" + payload2.countryCallingCode;
      }
    },

    resetPermanentAddress() {
      this.pApartmentName = "";
      this.pStreet = "";
      this.pBarangayId = null;
      this.pCityId = null;
      this.pCity = "";
      this.pState = "";
      this.pCountry = "";
      this.pPincode = "";
    },

    resetCurrentAddress() {
      this.cApartmentName = "";
      this.cStreet = "";
      this.cBarangayId = null;
      this.cCityId = null;
      this.cCity = "";
      this.cState = "";
      this.cCountry = "";
      this.cPincode = "";
    },

    //setting permanent address
    setPermanentAddress(addressData, fullData) {
      this.resetPermanentAddress();
      this.permanentAddress = fullData;
      for (const component of fullData.address_components) {
        const componentType = component.types[0];

        switch (componentType) {
          case "subpremise": {
            this.pApartmentName = component.long_name + "/";
            break;
          }

          case "street_number": {
            this.pApartmentName = this.pApartmentName + component.long_name;
            break;
          }

          case "street_address":
          case "premise":
          case "establishment":
          case "route": {
            this.pApartmentName && this.pApartmentName.length
              ? (this.pApartmentName =
                  this.pApartmentName + ", " + component.long_name)
              : (this.pApartmentName = component.long_name);
            break;
          }

          case "neighborhood":
          case "sublocality_level_3":
          case "sublocality_level_2":
          case "sublocality_level_1": {
            this.pStreet =
              this.pStreet && this.pStreet.length
                ? (this.pStreet = this.pStreet + ", " + component.long_name)
                : (this.pStreet = component.long_name);
            break;
          }

          case "locality": {
            this.pCity && this.pCity.length
              ? ""
              : (this.pCity = component.long_name);
            break;
          }

          case "administrative_area_level_2":
          case "administrative_area_level_3": {
            this.pCity && this.pCity.length
              ? this.pStreet && this.pStreet.length
                ? (this.pStreet = this.pStreet + ", " + component.long_name)
                : (this.pStreet = component.long_name)
              : (this.pCity = component.long_name);
            break;
          }

          case "administrative_area_level_1": {
            this.pCity && !this.pCity.length
              ? (this.pCity = component.long_name)
              : "";
            this.pState = component.long_name;
            break;
          }

          case "country": {
            this.pCountry = component.short_name;
            break;
          }

          case "postal_code": {
            this.pPincode = component.long_name;
            break;
          }

          case "postal_code_prefix":
          case "postal_code_suffix": {
            this.pPincode =
              this.pPincode && this.pPincode.length
                ? (this.pPincode = `${this.pPincode}-${component.long_name}`)
                : (this.pPincode = component.long_name);
            break;
          }
        }
      }
      let cityInDropdownFlag = false;
      for (let city of this.cityStateList) {
        if (city.City_Name.toLowerCase() == this.pCity.toLowerCase()) {
          this.pCityId = city.City_Id;
          this.pCity = city.City_Name;
          cityInDropdownFlag = true;
        }
      }
      if (!cityInDropdownFlag) {
        this.pCity = "";
      }
      this.onChangeAddressFlag();
    },

    //setting current address
    setCurrentAddress(addressData, fullData) {
      this.resetCurrentAddress();
      this.currentAddress = fullData;
      for (const component of fullData.address_components) {
        const componentType = component.types[0];

        switch (componentType) {
          case "subpremise": {
            this.cApartmentName = component.long_name + "/";
            break;
          }

          case "street_number": {
            this.cApartmentName = this.cApartmentName + component.long_name;
            break;
          }

          case "street_address":
          case "premise":
          case "establishment":
          case "route": {
            this.cApartmentName && this.cApartmentName.length
              ? (this.cApartmentName =
                  this.cApartmentName + ", " + component.long_name)
              : (this.cApartmentName = component.long_name);
            break;
          }

          case "neighborhood":
          case "sublocality_level_3":
          case "sublocality_level_2":
          case "sublocality_level_1": {
            this.cStreet =
              this.cStreet && this.cStreet.length
                ? (this.cStreet = this.cStreet + ", " + component.long_name)
                : (this.cStreet = component.long_name);
            break;
          }

          case "locality": {
            this.cCity && this.cCity.length
              ? ""
              : (this.cCity = component.long_name);
            break;
          }

          case "administrative_area_level_2":
          case "administrative_area_level_3": {
            this.cCity && this.cCity.length
              ? this.cStreet && this.cStreet.length
                ? (this.cStreet = this.cStreet + ", " + component.long_name)
                : (this.cStreet = component.long_name)
              : (this.cCity = component.long_name);
            break;
          }

          case "administrative_area_level_1": {
            this.cCity && !this.cCity.length
              ? (this.cCity = component.long_name)
              : "";
            this.cState = component.long_name;
            break;
          }

          case "country": {
            this.cCountry = component.short_name;
            break;
          }

          case "postal_code": {
            this.cPincode = component.long_name;
            break;
          }

          case "postal_code_prefix":
          case "postal_code_suffix": {
            this.cPincode =
              this.cPincode && this.cPincode.length
                ? (this.cPincode = `${this.cPincode}-${component.long_name}`)
                : (this.cPincode = component.long_name);
            break;
          }
        }
      }
      let cityInDropdownFlag = false;
      for (let city of this.cityStateList) {
        if (city.City_Name.toLowerCase() == this.cCity.toLowerCase()) {
          this.cCityId = city.City_Id;
          this.cCity = city.City_Name;
          cityInDropdownFlag = true;
        }
      }
      if (!cityInDropdownFlag) {
        this.cCity = "";
      }
      this.onChangeAddressFlag();
    },

    addressInfoDetails() {
      return {
        pApartment_Name: this.pApartmentName,
        pStreet_Name: this.pStreet,
        pCity_Id: this.pCityId ? this.pCityId : null,
        pCity: this.pCity,
        pBarangay_Id: this.pBarangayId ? this.pBarangayId : null,
        pBarangay: this.pBarangay,
        pRegion: this.pRegion,
        pState: this.pState,
        pCountry: this.pCountry,
        pPincode: this.pPincode,
        cApartment_Name: this.cApartmentName,
        cStreet_Name: this.cStreet,
        cCity_Id: this.cCityId ? this.cCityId : null,
        cCity: this.cCity,
        cBarangay: this.cBarangay,
        cBarangay_Id: this.cBarangayId ? this.cBarangayId : null,
        cRegion: this.cRegion,
        cState: this.cState,
        cCountry: this.cCountry,
        cPincode: this.cPincode,
        Use_Location_Address: this.sameAsPermanent,
        Land_Line_No: this.landlineNo,
        Mobile_No: this.mobileNo,
        Mobile_No_Country_Code: this.mobileNoCountryCode,
        Emergency_Contact_No: this.emergencyContactNo,
        Emergency_Contact_Name: this.emergencyContactName,
        Emergency_Contact_Relation: this.emergencyContactRelation,
        Emergency_Contact_Address: this.emergencyContactAddress,
        Emergency_Contact_City: this.emergencyContactCity,
        Emergency_Contact_Country: this.emergencyContactCountry,
      };
    },
    onChangeAddressFlag() {
      if (this.sameAsPermanent) {
        this.cApartmentName = this.pApartmentName;
        this.cStreet = this.pStreet;
        this.cBarangay = this.pBarangay;
        this.cBarangayId = this.pBarangayId;
        this.cBarangayList = this.pBarangayList;
        this.cCityId = this.pCityId;
        this.cCity = this.pCity;
        this.cRegion = this.pRegion;
        this.cState = this.pState;
        this.cCountry = this.pCountry;
        this.cPincode = this.pPincode;
      }
    },
    validateAddressInfo() {
      return new Promise((resolve) => {
        this.$refs.addressInfoValidationObserver
          .validate()
          .then((validationResponse) => {
            let invalidFields = [];
            Object.keys(this.$refs).forEach((refName) => {
              const field = this.$refs[refName];
              if (field && field.errors && field.errors.length > 0) {
                invalidFields.push(refName);
              }
            });
            if (invalidFields.length > 0) {
              let firstField = this.$refs[invalidFields[0]];
              firstField.$el.scrollIntoView({
                behavior: "smooth",
                block: "center",
              });
            }
            if (this.mobileNo && this.mobileNoCountryCode) {
              resolve(validationResponse);
            }
          });
      });
    },
    onChangePermanentAddress() {
      this.onChangeAddressFlag();
    },
  },
};
</script>
